const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]'];

/**
 * SNAP-2393: a plaintext ws:// collaboration socket is only allowed to loopback. Any other ws://
 * is upgraded to wss://, so an env value cannot silently send document content in the clear.
 */
export function resolveCollaborationUrl(raw: string): string {
  if (!/^ws:\/\//i.test(raw)) return raw;

  let hostname: string;
  try {
    hostname = new URL(raw).hostname;
  } catch {
    return raw;
  }

  if (LOCAL_HOSTNAMES.includes(hostname)) return raw;
  return raw.replace(/^ws:\/\//i, 'wss://');
}
